<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<cas-topbar title="Caster" [topbarView]="TopbarView.CASTER_HOME" [topbarColor]="topbarColor"
  [topbarTextColor]="topbarTextColor" [sidenav]="null"></cas-topbar>

<div class="content-container">
  <cas-project-list
    [projects]="projects | async" [isLoading]="isLoading$ | async">
  </cas-project-list>
</div>
